import history from '@history';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showMessage } from 'app/store/core/messageSlice';
import { BootstrapContext } from 'app/bootstrap/BootstrapContext';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import WdPageSimple from '@main/core/WdPageSimple';
import { ComposedHeader, FormCardLayout, LargeAvatar, TextWithLabel } from '@main/components';
import { getAdminById, getScopes } from 'app/api/admin';
import { useRequest, useMatchScopes } from '@main/hooks';
import { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { Chip, Typography } from '@mui/material';
import { hasScope } from 'app/scopes/scopes';

const allScopesMsg = 'Este administrador cuenta con todos los permisos y accesos';

const Root = styled(WdPageSimple)(({ theme }) => ({
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));
// export const Profile: React.FC<ProfileProps> = () => {
export const ProfileAdmins = () => {
  const Dispatch = useDispatch();

  const { finalizeSession } = useContext(BootstrapContext);
  const { id: previousId } = useParams();
  const { config } = useSelector((state) => state.config);
  const { api } = config;
  const { scopes: selfScopes } = useSelector((state) => state.profile);
  const [currentSubject, setCurrentSubject] = useState({
    id: '',
    name: '',
    email: '',
    phone: '',
    role: '',
    scopes: [],
    avatar: undefined,
  });

  const handleOnForbidden = async () => {
    await finalizeSession();
  };

  const handleOnError = async (message) => {
    Dispatch(showMessage({ message }));
  };
  const {
    makeRequest: getCurrentAdmin,
    isLoading: isLoadingAdmin,
    response: responseShowAdmin,
  } = useRequest(getAdminById, {
    onForbidden: handleOnForbidden,
    onError: handleOnError,
  });

  const { list: userScopeList } = useMatchScopes(currentSubject.scopes, getScopes);

  // ------ Funcion para cargar los datos obtenidos de request
  const handleLoadToForm = (previousData) => {
    const result = _.omit(previousData, ['updated_at', 'created_at']);
    setCurrentSubject(result);
    console.log(result);
  };

  // ------ Realiza request para cargar información del admin
  useEffect(() => {
    if (!previousId) {
      return;
    }
    getCurrentAdmin(previousId);
  }, []);

  // ------ Escucha response de request de Admin
  useEffect(() => {
    console.log(responseShowAdmin);
    if (!responseShowAdmin) {
      return;
    }
    handleLoadToForm(responseShowAdmin);
  }, [responseShowAdmin]);

  return (
    <Root
      header={<ComposedHeader decorator="button" />}
      content={
        <Box
          className="flex flex-col items-center"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <FormCardLayout title="Perfil de Administrador">
            <FormCardLayout.HalfColum>
              <div className="flex flex-auto flex-col justify-center items-center">
                <LargeAvatar
                  baseUri={api?.host}
                  color={currentSubject?.backgroundColor}
                  path={
                    currentSubject.avatar
                      ? currentSubject.avatar.fullPathThumb || currentSubject.avatar.fullPath
                      : undefined
                  }
                  name={currentSubject.name}
                />
              </div>
            </FormCardLayout.HalfColum>
            <FormCardLayout.HalfColum>
              <TextWithLabel title="Nombre">{currentSubject.name}</TextWithLabel>
              <TextWithLabel title="Correo">{currentSubject.email}</TextWithLabel>
              {currentSubject.phone && (
                <TextWithLabel title="Número telefónico">{currentSubject.phone}</TextWithLabel>
              )}
              {currentSubject.company && (
                <TextWithLabel title="Empresa">{currentSubject.company}</TextWithLabel>
              )}
            </FormCardLayout.HalfColum>
            <FormCardLayout.RowButton>
              <Button color="info" variant="contained" onClick={() => history.back()}>
                Regresar
              </Button>
              {hasScope(selfScopes, 'Admins', 'update') && (
                <Button
                  color="info"
                  variant="contained"
                  onClick={() => history.push(`/admin/update/${previousId}`)}
                >
                  Editar información
                </Button>
              )}
              {hasScope(selfScopes, 'Admins', 'update') && (
                <Button
                  color="primary"
                  onClick={() => history.push(`/admin/recovery/${previousId}`)}
                  variant="contained"
                >
                  Cambiar contraseña
                </Button>
              )}
            </FormCardLayout.RowButton>
          </FormCardLayout>
          <FormCardLayout title="Permisos y accesos">
            <FormCardLayout.FullColum>
              {currentSubject.scopes.includes('*') ? (
                <Chip label={allScopesMsg} />
              ) : (
                userScopeList.map((scopeGroup) => (
                  <div key={scopeGroup.label} className="mb-24">
                    <Typography className="text-lg font-semibold leading-tight mb-8">
                      {scopeGroup.label}
                    </Typography>
                    <Typography className="text-base font-light leading-tight" color="light">
                      {scopeGroup.description}
                    </Typography>
                    <div className="mt-12">
                      {scopeGroup.scopes.map((scope) => {
                        return <Chip key={scope.key} label={scope.value} className="mr-4 mb-8" />;
                      })}
                    </div>
                  </div>
                ))
              )}
            </FormCardLayout.FullColum>
          </FormCardLayout>
        </Box>
      }
    />
  );
};
